import React from 'react';
import { PostItemProps } from './post-item.props';
import Image from '@elements/image';
import Link from 'next/link';
import routes from '@routes';
import PostItemSchema from '@schema/post/post-item';
import { Button, Div, Text } from '@pezeshk-book/ui-kit';
import SynchronizeIcon from '@icons-components/synchronize-icon';
import convertDate from '@utils/time/convert-date';
import getParseRoute from '@utils/helpers/parse-route';
import LikeIcon from '@icons-components/like-icon';
import DislikeIcon from '@icons-components/dislike-icon';

const PostItem = ({ image, typeTitle, context, dislike = 0, like = 0, row, title, slug, publishedAt }: PostItemProps) => {
  return (
    <Div className={`flex-start w-full ${row ? 'flex-col sm:!flex-row-reverse' : 'flex-col sm:flex-row'}`} itemScope itemType="https://schema.org/BlogPosting">
      <Div className={'flex-col'}>
        <Link prefetch={true} passHref={true} href={getParseRoute({ pathname: routes['route.posts.show'], query: { slug: slug } })}>
          <Div className={'relative sm:h-[448px] h-[274px] max-h-[448px] sm:w-[336px] md:w-[636px]'}>
            <Image
              priority={true}
              sizes={'50vw'}
              fill={true}
              className={`object-cover ${row ? 'rounded-tl-[20px] sm:rounded-tl-[40px] md:rounded-tl-[100px] rounded-tr-0 sm:rounded-tr-xl' : 'rounded-tl-0 sm:rounded-tl-xl rounded-tr-[20px] sm:rounded-tr-[40px] md:rounded-tr-[100px]'}`}
              src={image}
              alt={'image'}
            />
          </Div>
        </Link>
      </Div>
      <Div className={`flex-col ${row ? 'sm:ml-4 md:ml-32' : 'sm:mr-4 md:mr-32'} w-full justify-between`}>
        <Div className={'flex-col'}>
          <Div className={'mt-4 mb-2 sm:mb-4 md:mb-7 flex items-center before:ml-2 before:w-2 before:h-11 sm:before:h-14 before:bg-tertiary-500'}>
            <Div className={'flex-col'}>
              <Text align={'right'} typography={'lg'} color={'tertiary'}>{typeTitle}</Text>
              <Link prefetch={true} passHref={true} href={getParseRoute({ pathname: routes['route.posts.show'], query: { slug: slug } })}>
                <Text itemProp="name headline" align={'right'} type={'bold'} typography={'xl'}>
                  {title}
                </Text>
              </Link>
            </Div>
          </Div>
          <Text variant={'span'} align={'right'} className={'text-justify'}>
            {context}
            <Button color={'tertiary'} className={'!p-1 !inline'} variant={'text'} href={getParseRoute({ pathname: routes['route.posts.show'], query: { slug: slug } })}>
              ادامه مطلب
            </Button>
          </Text>
        </Div>
        <Div className={'w-full justify-between mt-4'}>
          <Div className={`gap-3 sm:gap-6 items-center`}>
            <Button
              color={'control'}
              variant={'text'}
              startAdornment={<DislikeIcon/>}
              className={'items-center !p-0'}>
              {dislike}
            </Button>
            <Button
              color={'control'}
              variant={'text'}
              startAdornment={<LikeIcon/>}
              className={'items-center !p-0'}>
              {like}
            </Button>
          </Div>
          <Div className={'gap-1 items-center'}>
            <Div className={'relative w-4 h-4 text-grey-500'}>
              <SynchronizeIcon/>
            </Div>
            <Text color={'grey.500'} typography={'sm'}>آخرین بروزرسانی:</Text>
            <Text color={'grey.500'} typography={'sm'}>{convertDate(publishedAt, 'DD MMMM YYYY')}</Text>
          </Div>
        </Div>
      </Div>
      <PostItemSchema
        slug={slug}
        publishedAt={publishedAt}
        image={image}
      />
    </Div>
  );
};

export default PostItem;
